import React, { Fragment } from 'react'

export default ({ on }) => (
  <Fragment>
    {on ? '▼' : '▲'}
  </Fragment>
)
